



import React from "react";
import { Modal, Button } from "react-bootstrap";
import Lottie from "react-lottie";
import * as animationData from "./Download_Modal.json";

const Download_Modal = ({ show, handleClose }) => {
   const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="success_modal_div"
    >
      <Modal.Body className="success_modal text-center">
        <div className="success_lottie">

        <Lottie className="me-auto lottie" options={defaultOptions}/>
        </div>
        <h5>Download Successfull</h5>
      </Modal.Body>
    </Modal>
  );
};

export default Download_Modal;
